module.exports = {"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/lambda-2014-11-11.paginators.json
// module id = 392
// module chunks = 1